module.exports = __webpack_public_path__ + "img/shanhu-tree1.96a7252c.png";